import axiosInstance from "./axiosInstance";


const NewsAPI = {
    getNewsData: async() => {
        const response = await axiosInstance.get("/front/news?show_in_homepage=0");
        return response.data;
    },
    getTypeData: async() => {
        const response = await axiosInstance.get("/admin/types");
        return response.data;
    },
    getNewsTypeData: async(type_id) => {
        const response = await axiosInstance.get(`/front/news?type_id=${type_id}&show_in_homepage=0`);
        return response.data;
    },
    getStatsData: async(typedata) => {
        const response = await axiosInstance.get(`/front/news/${typedata}`);
        return response.data;
    },
    getPagesNewsData: async() => {
        const response = await axiosInstance.get("/front/pages/news");
        return response.data;
    },
    getServiceDetailsData: async(id) => {
        const response = await axiosInstance.get(`/front/service_page/${id}`);
        return response.data;
    },
};

export default NewsAPI;